import React from 'react';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
// import { colors } from '../styles';
import MobileNav from './MobileNav';
// import ContactModal from './ContactModal';
// import { CompareMobile } from './CompareMobile';

const styles = css`
  position: fixed;
  left: 0;
  bottom: 0;
  height: 60px;
  width: calc(100vw - 56px);
  z-index: 51;
  @media (min-width: 992px) {
    display: none;
  }
`;

function OSCTagMobile() {
  return (
    <div className={styles} >
      <MobileNav />
    </div>
  );
}

OSCTagMobile.propTypes = {
};

export default withData(
  {
    community: true,
    agent: true,
  },
  {
    required: {
      agent: true,
    },
  },
)(OSCTagMobile);



// WEBPACK FOOTER //
// ./src/components/MobileFooter.js